import React from "react";
import { FIELD_REGISTRY } from "./Config/fieldRegistry";
function ProductServiceInformation({
    formData,
    handleChange,
    config,
    errors
}) {
    const serviceFields = config?.fields?.service || [];
  
    if (serviceFields.length === 0) {
        return null;
    }
    const renderField = (fieldName) => {
        const field = FIELD_REGISTRY[fieldName];
        if (!field) {
            return null;
        }
        const value = formData[fieldName] || '';
        const error = errors?.[fieldName];
        if (field.type === 'select') {
            const options = typeof field.options === 'string' ? []
                : field.options || [];
            return (
                <div className="col-md-6 mb-3" key={fieldName}>
                    <label className="form-label">
                        {field.label}
                        {field.required && <span className="text-danger"> *</span>}
                    </label>
                    <select
                        className={`form-control ${error ? 'is-invalid' : ''}`}
                        name={fieldName}
                        value={value}
                        onChange={handleChange}
                    >
                        <option value="">Select {field.label}</option>
                        {options.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                    {error && <div className="invalid-feedback">{error}</div>}
                </div>
            );
        }
        if (field.type === 'textarea') {
            return (
                <div className="col-md-12 mb-3" key={fieldName}>
                    <label className="form-label">
                        {field.label}
                        {field.required && <span className="text-danger"> *</span>}
                    </label>
                    <textarea
                        className={`form-control ${error ? 'is-invalid' : ''}`}
                        name={fieldName}
                        value={value}
                        onChange={handleChange}
                        placeholder={field.placeholder}
                        rows={field.rows || 3}
                    />
                    {error && <div className="invalid-feedback">{error}</div>}
                </div>
            );
        }
        return (
            <div className="col-md-6 mb-3" key={fieldName}>
                <label className="form-label">
                    {field.label}
                    {field.required && <span className="text-danger"> *</span>}
                </label>
                <input
                    type={field.type === 'price' ? 'number' : field.type || 'text'}
                    className={`form-control ${error ? 'is-invalid' : ''}`}
                    name={fieldName}
                    value={value}
                    onChange={handleChange}
                    placeholder={field.placeholder || `Enter ${field.label}`}
                    step={field.type === 'price' ? '0.01' : '1'}
                    min={field.validation?.min}
                    max={field.validation?.max}
                />
                {error && <div className="invalid-feedback">{error}</div>}
            </div>
        );
    };

    return (
        <div className="card mb-3">
            <div className="card-header">
                <h5>Service Information</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    {serviceFields.map((fieldName) => renderField(fieldName))}
                </div>
            </div>
        </div>
    );
}

export default ProductServiceInformation;